import React from 'react';
import { AppSetting } from 'dependencies/appsettings';
import styles from './user-profile-heading.scss';
import { ButtonCallToAction } from 'ui';
import { externalRedirect } from 'app/infrastructure/platform';

interface UserProfileHeadingProps {
  className?: string;
  title: string;
  showVeracityProfileLink?: boolean;
  veracityProfileLinkTitle?: string;
}

export const UserProfileHeading = ({ className, title, showVeracityProfileLink, veracityProfileLinkTitle }: UserProfileHeadingProps) => {

  const isVeracityEnabled = (AppSetting.FeatureToggle || {} as any).veracityEnabled;
  const veracityProfileLink = AppSetting.VeracityProfileLink;
  const redirectToVeracityProfile = () => externalRedirect(veracityProfileLink);

  return (<>
    <div className={`${styles.headerWrapper} ${className} header-panel`}>
      <div className={`main-grid ${isVeracityEnabled ? styles.flexContainer : ''}`}>
        <div className={styles.headerPanel}>
          <h2>{title}</h2>
        </div>
        {
          showVeracityProfileLink && isVeracityEnabled && !!veracityProfileLink && <ButtonCallToAction
            id="veracity-profile-link"
            onClick={redirectToVeracityProfile}
            disabled={false}>
            {veracityProfileLinkTitle}
          </ButtonCallToAction>
        }
      </div>
    </div>
  </>);
};
